import * as React from "react";
const SvgCopy = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.813 1.871v17.166H4.31V3.38H14.342V1.87H8.578Zm2.812 2.815v17.443h15.562V9.346l-2.33-2.33-2.33-2.33h-5.45zM7.123 6.19h7.412v5.157h5.154v9.273H7.123v-7.215Zm8.912.125L17.8 8.078 19.56 9.84H16.03V8.078c0-.969.003-1.762.004-1.762z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCopy;
